/* pantallas-alumno (C): EL ACOMODO DEL CENTRO DE ESTUDIO, EN UN SOLO LUGAR.

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   Lo leen la pagina (`pages/StudyCenter.js`) y su esqueleto (`EsqueletoDelCentro.js`): las dos cajas
   salen de las MISMAS cadenas, asi que al llegar los datos nada brinca (CE11).

   Anchos y cortes (4.1 del encargo y "Acomodo por tamano" de la parte 1):
   - contenido hasta 1200, centrado;
   - celular (abajo de 768): una columna; el boton de empezar vive en la barra fija de abajo;
   - tablet (768 a 1023): una columna, Settings debajo de la lista con su boton;
   - computadora (desde 1024): dos columnas, Settings de 340 hasta 1279 y de 380 desde 1280
     (ahi el boton dice "Start studying"; de 1024 a 1279, "Start", como hoy).
   Las cadenas van completas y literales: Tailwind solo genera lo que ve escrito. */

/* centro-espacio (orden de Carlos del 20-oct; manda sobre S1 de smoke-alumno): LA PANTALLA NO SE DESPLAZA, Y SE
   ACOMODA SOLA. La pagina mide AL MENOS el contenido del chasis (el `<main>`, o el scroller de la hoja en la app) y
   la caja de documentos se lleva TODO lo que sobra; su lista va ABSOLUTA dentro de ella y se desplaza por dentro. Sin
   alturas por aparato ni escalones: el alto lo pone la ventana que hay, y si cambia, el acomodo cambia con ella.
   La UNICA excepcion es la de los dos renglones: la caja de la lista tiene alto minimo de dos renglones de documento
   (56 + 8 + 56 = 120). Si la ventana es tan baja que ni eso cabe (telefono acostado, iPhone SE, ventana chaparra),
   la pagina crece y se desplaza, y nada se recorta ni se aprieta. */
// Desde 1024 la pagina mide EXACTAMENTE el alto del chasis: ahi solo Settings podria no caber, y en vez de
// estirar la pagina se desplaza por dentro (`PEGADO_EN_COMPU`).
export const PAGINA_DEL_CENTRO = 'mx-auto w-full max-w-[1200px] min-h-full lg:h-full flex flex-col gap-2 md:gap-3';

export const TITULO_DEL_CENTRO = 'text-[24px] leading-[28px] md:text-[34px] md:leading-tight font-bold text-[#F4F4F3]';

// Hasta 1023 una columna que se lleva lo que sobra; desde 1024 la rejilla de dos, con las dos cajas a lo alto
// (Settings se queda arriba con su alto: `PEGADO_EN_COMPU`). centro-espacio: desde 1024 la rejilla mide lo que sobra
// y nada mas (su renglon es `minmax(0,1fr)`), asi una ventana baja no la estira por Settings.
export const REJILLA_DEL_CENTRO = 'flex-1 flex flex-col gap-2 md:gap-3 lg:gap-4 lg:min-h-0 lg:grid lg:grid-rows-[minmax(0,1fr)] lg:grid-cols-[minmax(0,1fr)_340px] xl:grid-cols-[minmax(0,1fr)_380px]';

// El recuadro del Panel (fondo #141414, borde #222222, radio 18). centro-espacio: relleno 12 a los lados y 10 arriba y
// abajo en el celular, y 16 desde 768 (era 16 y 20).
export const RECUADRO_DEL_CENTRO = 'min-w-0 rounded-[18px] border border-[#222222] bg-[#141414] px-3 py-2.5 md:p-4';

// Settings en computadora va arriba con su alto (no se estira con la caja de documentos) y, si la pagina llegara a
// desplazarse, se queda pegado arriba. centro-espacio: si la ventana es tan baja que Settings no cabe en su columna,
// se desplaza POR DENTRO (lo unico que se desplaza es lo de dentro de los cuadros).
export const PEGADO_EN_COMPU = 'lg:sticky lg:top-6 lg:self-start lg:max-h-full lg:overflow-y-auto lg:overscroll-contain';

// Settings se ve entero siempre: en la columna del telefono y la tablet no se encoge.
export const SETTINGS_DEL_CENTRO = 'shrink-0';

// La caja "Select Documents" toma la altura que sobra (en la columna y, desde 1024, a lo alto de la rejilla).
export const RECUADRO_DE_DOCUMENTOS = 'flex-1 flex flex-col';

export const TITULO_DEL_RECUADRO = 'text-[19px] leading-6 font-semibold text-[#F4F4F3] flex items-center gap-2';

// La caja de la lista se lleva lo que sobra; su minimo son DOS renglones de documento (la regla de arriba).
export const CAJA_DE_LA_LISTA = 'relative mt-2 md:mt-3 flex-1 min-h-[120px]';

// La lista de documentos: llena su caja y se desplaza por dentro, barrita de 4 #3A3A3A y separacion de 8 entre
// renglones. Siempre absoluta: nunca empuja la pagina.
export const LISTA_DEL_CENTRO = 'absolute inset-0 flex flex-col gap-2 overflow-y-auto overscroll-contain pr-1 [scrollbar-width:thin] [scrollbar-color:#3A3A3A_transparent] [&::-webkit-scrollbar]:w-1 [&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar-thumb]:bg-[#3A3A3A] [&::-webkit-scrollbar-thumb]:rounded-full';

// El degradado de 48 que avisa que hay mas abajo.
export const DEGRADADO_DE_LA_LISTA = 'pointer-events-none absolute left-0 right-1 bottom-0 h-12 bg-gradient-to-t from-[#141414] to-transparent';

// Lo de dentro de Settings, apretado (centro-espacio: 8 entre piezas en el celular y 10 desde 768; era 16).
export const CUERPO_DE_SETTINGS = 'mt-2 md:mt-2.5 flex flex-col gap-2 md:gap-2.5';

// El pie de Settings (tablet y computadora): "{n} documents selected" y el boton de 52.
// centro-espacio-2 (orden de Carlos del 20-oct): "{n} documents selected" solo desde 1024 (en la tablet, solo el boton).
export const PIE_DE_SETTINGS = 'max-md:hidden mt-2 flex flex-col gap-2';
export const DOCS_ELEGIDOS = 'max-lg:hidden text-[13px] leading-[18px] text-[#9A9A9A]';

/* centro-espacio-2 (orden de Carlos del 20-oct): en Exam, en el celular, Settings se aprieta para que la pagina no se
   mueva en ningun telefono (en 393 x 659 faltaban 26 px). Sin quitar el titulo y sin bajar letras ni toques: el relleno
   del recuadro de 10 a 8, el renglon del titulo de 24 a 20 (la letra sigue en 19), lo de dentro de 8 a 4 arriba y 6
   entre piezas, y la separacion con la caja de documentos de 8 a 4. Las perillas se aprietan en `CajaDeNumero`. */
/* tutor-1 (E): la web del telefono tomo la pildora de la app, que tapa 14 px mas que la barra plana de antes (70
   contra 56), y Exam volvio a desplazarse (12 px en 393 x 659; el iPhone SE, 21 en vez de 7). Se devuelven esos 14 px
   en el mismo celular y con la misma regla: la separacion de la pagina de 8 a 4 (dos veces), el relleno de la caja de
   documentos de 10 a 8 (igual que Settings) y la lista de 8 a 6 de su titulo. */
export const APRETADO_EN_EXAM = {
  pagina: 'max-md:gap-1',
  documentos: 'max-md:py-2',
  lista: 'max-md:mt-1.5',
  rejilla: 'max-md:gap-1',
  recuadro: 'max-md:py-2',
  titulo: 'max-md:leading-5',
  cuerpo: 'max-md:mt-1 max-md:gap-1.5',
};

/* centro-espacio: el aire entre Settings y la barra fija del celular. La pagina lleva abajo el alto que la barra le
   tapa MAS este aire, medido en vivo (la barra crece con los renglones de mas de su aviso). */
export const AIRE_SOBRE_LA_BARRA = 12;
